import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import { CustomButton, Text, CustomTable } from "../../shared/uiComponents";
import { useCheckPermission } from "../../shared/Helpers/hooks";
import { AdminTypes } from "../../components/Menu";
import SearchBar from "../../components/SearchBar";
import { Container, Header } from "../../components/StyledComponents";
import { PERMISSIONS } from "../../App/constants";

import { DispatchProperties, useSelector } from "../../redux/store";
import { getClinicalSupervisors } from "../../redux/State/userSlice";
import { Headers, TableBody } from "../Admins/tableInfo";

const ClinicalSupervisor = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<DispatchProperties>();
  const { permissionGranted } = useCheckPermission(PERMISSIONS.USER.CREATE);
  const [params] = useSearchParams();

  const usersData = useSelector((state) => state.user.clinicalSupervisors);
  const loading = useSelector((state) => state.user.loading);

  useEffect(() => {
    const page = params.get("page") || "1";
    const pageSize = params.get("pageSize") || "8";
    const orderBy = params.get("orderBy") || "";
    const direction = params.get("direction") || "";
    const searchString = params.get("search") || "";

    dispatch(
      getClinicalSupervisors({
        page,
        pageSize,
        orderBy,
        direction,
        searchString,
      })
    );
  }, [params, dispatch]);

  const addClinicalSupervisorHandler = () => {
    window.localStorage.setItem("formType", AdminTypes[3]);
    navigate("/cs/new");
  };

  return (
    <Container>
      <Header>
        <Text title={"Clinical Supervisor"} size="mediumBold" />
        <Header>
          {permissionGranted && (
            <CustomButton
              title={"Add Clinical Supervisor"}
              className={"marginRight16"}
              onClick={addClinicalSupervisorHandler}
            />
          )}
          <SearchBar />
        </Header>
      </Header>
      <CustomTable
        headers={Headers}
        data={usersData}
        TableBody={TableBody}
        loading={loading}
      />
      {/* <MobileView {...usersData} /> */}
    </Container>
  );
};

export default ClinicalSupervisor;
